<template>
  <b-container fluid>
    <b-row>
      <b-col cols="auto">
        <filter-component
          :from-date.sync="fromDate"
          :to-date.sync="toDate"
          :date-type.sync="dateType"
          :report-type.sync="reportTypeSelect"
        />
      </b-col>
      <b-col cols="auto">
        <b-button variant="warning" @click="filterReport">แสดง</b-button>
      </b-col>
      <b-col cols="auto" class="text-left">
        <b-button
          variant="success"
          :disabled="!itemsObject"
          @click="printReport"
          >ออกรายงาน</b-button
        >
      </b-col>
       <b-col cols="auto" class="text-left">
        <b-button
          variant="success"
          :disabled="!itemsObject"
          @click="printReportExcel"
          >ออกรายงาน Excel</b-button
        >
      </b-col>
    </b-row>
    <b-container class="table-wrapper" fluid>
      <b-row
        v-show="reportType !== 'invoiceReport' && reportType !== null"
        align-v="center"
        class="filter-wrapper"
      >
        <b-col>
          <test-filter-component
            :status-filter.sync="statusFilter"
            :hospital-selected.sync="hospitalSelected"
            :direction-filter-selected.sync="directionFilterSelected"
            :credit-type-selected.sync="creditTypeSelected"
          />
        </b-col>
      </b-row>
      <b-row
        v-show="reportType === 'invoiceReport' && reportType !== null"
        align-v="center"
        class="filter-wrapper"
      >
        <b-col>
          <invoice-filter-component
            :filter-type.sync="filterType"
            :direction-filter-selected.sync="directionFilterSelected"
            :corporation-filter-selected.sync="corporationFilterSelected"
            :status-filter-selected.sync="statusFilter"
            :platforms-type.sync="platformsTypeFilter"
            :credit-type-selected.sync="creditTypeSelected"
          />
        </b-col>
      </b-row>
    </b-container>
    <b-row>
      <invoice-table
        v-show="reportType === 'invoiceReport'"
        ref="invoiceTableRef"
        :report-type="reportType"
        :date-type="dateType"
        :from-date="fromDate"
        :to-date="toDate"
        :items-filter.sync="itemsFilter"
        :items-object.sync="itemsObject"
        :status-filter="statusFilter"
        :direction-filter-selected="directionFilterSelected"
        :corporation-filter-selected="corporationFilterSelected"
        :platforms-type-filter="platformsTypeFilter"
        :filter-type="filterType"
        :credit-type-selected="creditTypeSelected"
      />
      <test-table
        v-show="reportType === 'testReport'"
        ref="testTableRef"
        :date-type="dateType"
        :report-type="reportType"
        :from-date="fromDate"
        :to-date="toDate"
        :hospital-selected="hospitalSelected"
        :status-filter="statusFilter"
        :direction-filter-selected="directionFilterSelected"
        :credit-type-selected="creditTypeSelected"
        :items-filter.sync="itemsFilter"
        :items-object.sync="itemsObject"
      />
      <animal-table
        v-show="reportType === 'animalReport'"
        ref="animalTableRef"
        :date-type="dateType"
        :report-type="reportType"
        :from-date="fromDate"
        :to-date="toDate"
        :hospital-selected="hospitalSelected"
        :status-filter="statusFilter"
        :direction-filter-selected="directionFilterSelected"
        :credit-type-selected="creditTypeSelected"
        :items-filter.sync="itemsFilter"
        :items-object.sync="itemsObject"
      />
      <specimen-table
        v-show="reportType === 'specimenReport'"
        ref="specimenTableRef"
        :date-type="dateType"
        :report-type="reportType"
        :from-date="fromDate"
        :to-date="toDate"
        :hospital-selected="hospitalSelected"
        :status-filter="statusFilter"
        :direction-filter-selected="directionFilterSelected"
        :credit-type-selected="creditTypeSelected"
        :items-filter.sync="itemsFilter"
        :items-object.sync="itemsObject"
      />
    </b-row>
  </b-container>
</template>

<script>
import FilterComponent from "../../components/Account/Report/FilterComponent";
import InvoiceTable from "../../components/Account/Report/invoiceTable";
import TestTable from "../../components/Account/Report/testTable";
import Account from "../../services/API/Account";
import axios from "axios";
import AnimalTable from "../../components/Account/Report/animalTable";
import SpecimenTable from "../../components/Account/Report/specimenTable";
import moment from "moment";
// import printJS from "print-js";
import testFilterComponent from "../../components/Account/Report/testFilterComponent";
import InvoiceFilterComponent from "../../components/Account/Report/invoiceFilterComponent";

export default {
  name: "ReportView",
  components: {
    SpecimenTable,
    AnimalTable,
    FilterComponent,
    InvoiceTable,
    TestTable,
    testFilterComponent,
    InvoiceFilterComponent,
  },
  data() {
    return {
      // filter for all invoice
      statusFilter: null,
      directionFilterSelected: null,

      // filter for invoice only
      filterType: "all",
      corporationFilterSelected: null,
      platformsTypeFilter: "corporation",

      // filer for all except invoice
      hospitalSelected: null,
      creditTypeSelected: null,

      reportType: null,
      reportTypeSelect: null,
      dateType: "month",
      fromDate: null,
      toDate: null,
      itemsFilter: [],
      itemsObject: null,
    };
  },
  watch: {
    reportTypeSelect(value) {
      this.reportType = value;
      this.statusFilter = null;
      this.directionFilterSelected = null;
      this.filterType = "all";
      this.corporationFilterSelected = null;
      this.platformsTypeFilter = "corporation";
      this.hospitalSelected = null;
      this.creditTypeSelected = null;
    },
    // reportType(value) {
    //   if (value === 'invoiceReport') {
    //     this.$refs.invoiceTableRef.filters()
    //   } else if (value === 'testReport') {
    //     this.$refs.testTableRef.filters()
    //   } else if (value === 'animalReport') {
    //     this.$refs.animalTableRef.filters()
    //   } else if (value === 'specimenReport') {
    //     this.$refs.specimenTableRef.filters()
    //   }
    // }
  },
  mounted() {
    this.fromDate = new Date(moment().startOf("month"));
    this.toDate = new Date(moment().endOf("month"));
  },
  methods: {
    async filterReport() {
      this.reportType = this.reportTypeSelect;
      if (this.reportType === "invoiceReport") {
        this.$refs.invoiceTableRef.filters();
      } else if (this.reportType === "testReport") {
        this.$refs.testTableRef.filters();
      } else if (this.reportType === "animalReport") {
        this.$refs.animalTableRef.filters();
      } else if (this.reportType === "specimenReport") {
        this.$refs.specimenTableRef.filters();
      } else {
        this.$swal.fire("Warning", "กรุณาเลือกประเภทรายงาน", "warning");
      }
    },
    async printReport() {
      this.$store.state.isLoading = true
      let reportPrint;
      try {
        reportPrint = await Account.reportPrint({
          report_type: this.reportType,
          results: this.itemsObject.result,
          date_type: this.itemsObject.date_type,
          start_date: this.itemsObject.start_date,
          to_date: this.itemsObject.to_date,
          type_name: this.itemsObject.type_name,
          type: this.filterType,
        });
      } catch (err) {
        this.$store.state.isLoading = false
        this.$swal.fire(err.message);
      }

      this.$store.state.isLoading = false
      if (reportPrint) {
        let newTab = window.open(
          `${process.env.VUE_APP_IP}/storage/${reportPrint.url}`,
          "_blank"
        );
        axios({
          type: "POST",
          url: "/echo/json/",
          success: function (data) {
            newTab.location;
          },
        });
      } else {
        this.$swal.fire(reportPrint);
        return;
      }

      // let uriPath = `report-print?report_type=${this.reportType}&result=${JSON.stringify(this.itemsObject.result)}&date_type=${this.itemsObject.date_type}&start_date=${this.itemsObject.start_date}&to_date=${this.itemsObject.to_date}&type_name=${this.itemsObject.type_name}`

      // printJS({printable:`${process.env.VUE_APP_IP}${uriPath}`, type:'pdf', showModal:true, })
    },
    async printReportExcel() {
      this.$store.state.isLoading = true
      let reportPrint;
      try {
        reportPrint = await Account.reportPrintExcel({
          report_type: this.reportType,
          results: this.itemsObject.result,
          date_type: this.itemsObject.date_type,
          start_date: this.itemsObject.start_date,
          to_date: this.itemsObject.to_date,
          type_name: this.itemsObject.type_name,
          type: this.filterType,
        });
      } catch (err) {
        this.$store.state.isLoading = false
        this.$swal.fire(err.message);
      }

      this.$store.state.isLoading = false
      if (reportPrint) {
        let newTab = window.open(
          `${process.env.VUE_APP_IP}/storage/${reportPrint.url}`,
          "_blank"
        );
        axios({
          type: "POST",
          url: "/echo/json/",
          success: function (data) {
            newTab.location;
          },
        });
      } else {
        this.$swal.fire(reportPrint);
        return;
      }

      // let uriPath = `report-print?report_type=${this.reportType}&result=${JSON.stringify(this.itemsObject.result)}&date_type=${this.itemsObject.date_type}&start_date=${this.itemsObject.start_date}&to_date=${this.itemsObject.to_date}&type_name=${this.itemsObject.type_name}`

      // printJS({printable:`${process.env.VUE_APP_IP}${uriPath}`, type:'pdf', showModal:true, })
    },
  },
};
</script>

<style scoped>
.filter-wrapper {
  background: #eaeced;
  padding: 1rem;
}
.table-wrapper {
  padding: 1rem 2rem 0 2rem;
}
</style>
